import { FunctionalComponent, h } from '@stencil/core'
import { JSXBase } from '@stencil/core/internal'
import { escapeRegExp, memoize } from 'lodash-es'

export function truncate(text: string, wordCount: number, moreChar = '…') {
  let words = text.split(' ')
  if (words.length <= wordCount) {
    return text
  } else {
    words = words.slice(0, wordCount)
    words[wordCount - 1] = words[wordCount - 1].replace(/[^\w]*$/, moreChar)
    return words.join(' ')
  }
}

export const NoWrap: FunctionalComponent<JSXBase.IntrinsicElements['span']> = (
  { class: className = '', ...attrs },
  children
) => {
  return (
    <span {...attrs} class={`inline-block whitespace-no-wrap ${className}`}>
      {children}
    </span>
  )
}

export const stringToRegex = memoize((query: string, flags?: string) => {
  // eslint-disable-next-line
  return new RegExp(`(${escapeRegExp(query)})`, flags)
})
